import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { Response, IResponse } from '@shared/interfaces/response/response';
import { ProDefiniciones } from '@shared/interfaces/request/proDefiniciones';
import { ProDefApeValores } from '@shared/interfaces/request/proDefApeVal';

const httpOption = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

@Injectable({ providedIn: 'root' })
export class ProDefinicionesService {
  private _url =
    environment.apiBaseUrl + 'api/parametria/portafolio/prodefiniciones/';

  private newUrl = environment.apiNewBackBaseUrl;
  constructor(private _http: HttpClient) {}

  create(model: ProDefiniciones): Observable<Response> {
    return this._http.post<Response>(this._url, model, httpOption);
  }

  read(promocion: string): Observable<Response> {
    let url: string = this._url + promocion;
    return this._http.get<Response>(url);
  }

  update(model: ProDefiniciones): Observable<Response> {
    return this._http.put<Response>(this._url, model, httpOption);
  }

  delete(model: ProDefiniciones): Observable<Response> {
    return this._http.request<Response>('delete', this._url, {
      body: model,
    });
  }

  readOne(promocion: string, numVar: number): Observable<Response> {
    let url: string = this._url + promocion + '/' + numVar;
    return this._http.get<Response>(url);
  }

  //#region CRUD catblcalculovarpromo Apertura

  createProDefApeVal(model: ProDefApeValores): Observable<Response> {
    let url: string = this._url + 'prodefapeval/';
    return this._http.post<Response>(url, model, httpOption);
  }

  readProDefApeVal(promocion: string, numVar: number): Observable<Response> {
    let variables: string = promocion + '/' + numVar;
    let url: string = this._url + 'prodefapeval/' + variables;
    return this._http.get<Response>(url);
  }

  updateProDefApeVal(model: ProDefApeValores): Observable<Response> {
    let url: string = this._url + 'prodefapeval/';
    return this._http.put<Response>(url, model, httpOption);
  }

  //#endregion

  //#region Select's Pantalla Gastos

  proDefGasValores(iTipo: number): Observable<Response> {
    let url: string = this._url + 'prodefgasvalores/' + iTipo;
    return this._http.get<Response>(url);
  }

  getSolicitudesValores(sUsuario: string): Observable<IResponse>{
    const payload = {
      sUsuario: sUsuario,
      iTipo: 45
    };
    return this._http.post<IResponse>(this.newUrl + 'Solicitudes/ValoresPromocion', payload, httpOption);
  }
  //#endregion
}
